import React from "react";
import axios from "axios";
import { useState } from "react";
import { useParams } from "react-router";

const UpLoadHtml = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [signOneForAll, setSignOneForAll] = useState(false);
  const [withPlaceholders, setWithPlaceholders] = useState(false);
  const [digitalSignature, setDigitalSignature] = useState(false);
  const [disableFileUpload, setDisableFileUpload] = useState(false);

  const [res, setRes] = useState(false);

  const { id } = useParams();

  const onSubmit = (e) => {
    setError(false);
    setSuccess(false);
    setLoading(true);
    e.preventDefault();
    let data = {
      requestID: id,
      digitalSignature: digitalSignature,
      oneForAll: signOneForAll,
      withPlaceholders: withPlaceholders,
      signUpload: disableFileUpload,
      html: e.target.html.value,
    };

    axios
      .post(`/api/html/add`, data)
      .then((res) => {
        console.log(res);
        setRes(res.data.result);
        setLoading(false);
        setSuccess(true);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setError(true);
      });
  };

  return (
    <div>
      <div style={{ height: "100px" }}></div>
      <div className="d-flex jc-center">
        <div>
          <form onSubmit={onSubmit}>
            <h1>Upload Html</h1>
            <div>
              <textarea name="html" rows="30" cols="80" />
            </div>
            <div className="my-10 upload-html-checkbox-div">
              <div>
                <label>Sign One For All</label>
              </div>
              <input
                onChange={() => setSignOneForAll(!signOneForAll)}
                name="signall"
                type="checkbox"
                checked={signOneForAll}
              />
            </div>
            <div className="my-10 upload-html-checkbox-div">
              <label>With Placeholders</label>
              <input
                onChange={() => setWithPlaceholders(!withPlaceholders)}
                name="withPlaceholders"
                type="checkbox"
                checked={withPlaceholders}
              />
            </div>
            <div className="my-10 upload-html-checkbox-div">
              <label>Digital Signature</label>
              <input
                onChange={() => setDigitalSignature(!digitalSignature)}
                name="withPlaceholders"
                type="checkbox"
                checked={digitalSignature}
              />
            </div>

            <div className="my-10 upload-html-checkbox-div">
              <label>Enable File Upload</label>
              <input
                onChange={() => setDisableFileUpload(!disableFileUpload)}
                name="withPlaceholders"
                type="checkbox"
                checked={disableFileUpload}
              />
            </div>
            <button type="submit"> {loading ? "loading...." : "Upload"}</button>
          </form>
          {error ? <p>Html Already upload on {id} id</p> : ""}
          {success ? (
            <>
              <p>Html Upload Success on {id} id</p>
              <p>
                Link:&nbsp;
                {res.placeholderLink ? res.placeholderLink : res.signatureLink}
              </p>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default UpLoadHtml;
